import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { TransportadoraFilterCollapseComponent, TransportadoraFilterModalComponent } from './filter';
import { TypeaheadTransportadoraComponent } from './typeahead';

@NgModule({
    imports: [
        SharedModule,
        TypeaheadModule.forRoot()
    ],
    declarations: [
        TransportadoraFilterCollapseComponent,
        TransportadoraFilterModalComponent,
        TypeaheadTransportadoraComponent
    ],
    exports: [
        TransportadoraFilterCollapseComponent,
        TransportadoraFilterModalComponent,
        TypeaheadTransportadoraComponent
    ]
})
export class TransportadoraSharedModule { }
